import { Coins } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

/**
 * OKS-52 — Coin-to-XP ratio placeholder (V2 hold).
 *
 * The Coins ledger is not yet in Crew (PRD §1 / TRD KD-1). This
 * static `<Alert>` tells admins the surface is coming but the editor
 * lives in a future ticket. No inputs, no form, no save button.
 */
export function CoinRatioPlaceholder() {
  const { t } = useTranslation()

  return (
    <Alert data-testid="brand-settings-progression-coin-placeholder">
      <Coins aria-hidden="true" />
      <AlertTitle>{t("settings.brand.progression.coin.title")}</AlertTitle>
      <AlertDescription>
        {t("settings.brand.progression.coin.body")}
      </AlertDescription>
    </Alert>
  )
}
